<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content class="mat-typography">
  <mat-icon [ngClass]="getMode()">{{ getIcon() }}</mat-icon>
  <div class="flex-container">
    <div>{{ data.mainText }}</div>
    <small *ngIf="!!data.subText">({{ data.subText }})</small>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
